<script>
import {notificationMethods, settingsMethods, uploadMethods} from "@/state/helpers";

import { required } from "vuelidate/lib/validators";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import Toast from '../../../components/widgets/toast';
import appConfig from "@/app.config";


/**
 * Advanced table component
 */
export default {
  page: {
    title: "Ayarlar",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Toast
  },
  data() {
    return {
      toastAction:'',
      toastMessage:'',
      showToast:false,
      itemsLoaded: false,
      items: [],
      imgLoading:false,
      settings: {
        title: '',
        description: '',
        logo: '',
        theme: '',
      },
      title: "Ayarlar",
      headerItems: [
        {
          text: "Ana Sayfa",
          href: "/",
        },
        {
          text: "Ayarlar",
        },
      ],
      addSubmitted: false,
    };
  },
  validations: {
    settings: {
      title:{required},
      logo:{required},
      description: { required },
      theme: { required },
    },
  },
  computed: {
    /**
     * Total no. of records
     */
    rows() {
      return this.items.length;
    },
  },
  mounted() {
    this.settingsData();
  },
  methods: {
    ...settingsMethods,
    ...notificationMethods,
    ...uploadMethods,

    onImageChange(e){
      let files = e.target.files || e.data.transfer.files;
      if (!files.length)
        return;

      let data = new FormData()
      data.append('upload',files[0])
      data.append('folder','settings')
      let settings = this.settings;
      this.imgLoading=true;
      this.uploadFile(data).then((res)=>{
        settings.logo = res.url;
        this.imgLoading=false;
      })
    },

    settingsData(){
      this.itemsLoaded=false;
      this.getSettings().then(res=>{
        this.settings.title = res.title
        this.settings.description = res.description
        this.settings.logo = res.logo
        this.settings.theme = res.theme
        this.itemsLoaded=true;
      })
    },

    handleSubmit() {
      this.addSubmitted = true;
      this.$v.settings.$touch();
      if (
          this.$v.settings.$invalid
      ) {
        return;
      } else {
       this.saveSettings(this.settings).then(()=>{
          this.toastMessage="Ayarlar başarıyla kaydedildi";
          this.toastAction="success";
          this.showToast=true;
          setTimeout(()=>{
            this.showToast=false;
          },3000)
          this.showModal = false;
          this.settingsData();
        })
      }
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="headerItems" />
    <Toast :action="this.toastAction" :message="this.toastMessage" v-if="showToast"></Toast>
    <div class="row" v-if="itemsLoaded ">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <form @submit.prevent="handleSubmit">
              <div class="row">
                <div class="col-12">
                  <div class="mb-3">
                    <label for="title">Başlık</label>
                    <input
                        id="title"
                        type="text"
                        v-model="settings.title"
                        class="form-control"
                        placeholder="Başlık giriniz"
                        :class="{
                    'is-invalid': addSubmitted && $v.settings.title.$error,
                  }"
                    />
                    <div
                        v-if="addSubmitted && !$v.settings.title.required"
                        class="invalid-feedback"
                    >
                      Başlık girilmesi gerekli bir alandır.
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <div class="mb-3">
                    <label for="description">Site Açıklama</label>
                    <textarea
                        name="description"
                        id="description"
                        type="text"
                        autocomplete="off"
                        v-model="settings.description"
                        class="form-control"
                        placeholder="Açıklama giriniz"
                        :class="{
                    'is-invalid': addSubmitted && $v.settings.description.$error,
                  }"
                    />
                    <div
                        v-if="addSubmitted && $v.settings.description.$error"
                        class="invalid-feedback"
                    >
                      <span v-if="!$v.settings.message.required">Açıklama Metni girilmesi gerekli bir alandır.</span>
                    </div>
                  </div>
                </div>
                <div class="col-6">
                  <div class="mb-3">
                    <label for="logo" class="form-label">Logo</label>
                    <input
                        type="file"
                        id="logo"
                        @change="onImageChange"
                        accept="image/*"
                        class="form-control"
                        :class="{
                      'is-invalid': addSubmitted && !settings.logo,
                }"
                    />
                  </div>
                </div>
                <div class="col-6 d-flex justify-content-start mb-3">
                  <b-spinner v-if="imgLoading" class="m-5" variant="primary"></b-spinner>
                  <img v-else :class="settings.logo ? 'd-block' : 'd-none'" class="w-50" id="imgDisplay" :src="settings.logo" alt="listImage">
                </div>
                <div class="col-12">
                  <div class="mb-3">
                    <label for="theme">Tema</label>
                    <select name="theme"
                            id="theme"
                            v-model="settings.theme"
                            class="form-control">
                      <option value="light">Light</option>
                      <option value="dark">Dark</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="text-end mt-3">
                <b-button variant="light" @click="showModal = false"
                >Vazgeç</b-button
                >
                <b-button type="submit" variant="success" class="ms-1"
                >Kaydet</b-button
                >
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div class="spinner-wrapper" v-else>
      <b-spinner class="m-5" variant="secondary" role="status"></b-spinner>
    </div>
  </Layout>
</template>
<style scoped>
.pill {
  display: inline-block;
  margin: 10px 10px 0 0;
  padding: 6px 0px 4px 0px;
  background: #2a3042;
  border-radius: 10px;
  font-size: 12px;
  letter-spacing: 1px;
  font-weight: bold;
  color: #fff;
  cursor: pointer;
}
.pill span {
  padding: 6px 12px 4px 12px;
}
</style>
